import React, { useState } from "react";
import JobListing from "./JobListing";
import ApplicationForm from "./ApplicationForm";
import styles from "./styles";
import { motion } from "framer-motion";
import { useNavigate } from "@tanstack/react-router";

const HiringPage = () => {
  const [submitted, setSubmitted] = useState(false);
  const [customRole, setCustomRole] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);
  const navigate = useNavigate();

  const handleFormSubmit = () => {
    if (selectedRole && selectedRole !== "custom") {
      navigate({ to: `/talent/${selectedRole.toLowerCase()}` });
    } else {
      setSubmitted(true);
    }
  };

  return (
    <motion.div
      style={styles.container}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <header style={styles.header}>
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="w-px h-8 bg-silver/30"></div>
          <p className="text-xs font-mono tracking-[0.4em] text-silver/50 uppercase">
            Sacred Calling
          </p>
          <div className="w-px h-8 bg-silver/30"></div>
        </div>
        <h1 className="text-5xl md:text-7xl font-light mb-6 tracking-tight">Join Our</h1>
        <h1 className="text-5xl md:text-7xl font-light mb-8 tracking-tight text-silver/80">Sacred Mission</h1>
        <p className="text-silver/60 text-lg font-light">Where consciousness meets technology</p>
      </header>

      <main style={styles.main}>
        <JobListing onSelectRole={setSelectedRole} />

        {selectedRole === "custom" && (
          <motion.div
            style={{ marginTop: "2rem", ...styles.formContainer }}
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            <label style={styles.label}>Propose Your Sacred Role</label>
            <input
              style={styles.input}
              placeholder="Describe how you can serve our mission..."
              value={customRole}
              onChange={(e) => setCustomRole(e.target.value)}
            />
          </motion.div>
        )}

        <motion.section
          style={styles.formContainer}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h2 className="text-2xl font-light text-silver mb-6">Begin Your Journey</h2>
          {!submitted ? (
            <ApplicationForm onSubmit={handleFormSubmit} />
          ) : (
            <motion.div
              style={styles.thankYouMessage}
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 100 }}
            >
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-4 border-2 border-silver/30 rounded-full flex items-center justify-center">
                  <div className="w-8 h-8 bg-silver/60 rounded-full"></div>
                </div>
                <p className="text-silver/80 font-light">Your sacred application has been received.</p>
                <p className="text-silver/60 text-sm mt-2">We'll connect with you soon.</p>
              </div>
            </motion.div>
          )}
        </motion.section>
      </main>
    </motion.div>
  );
};

export default HiringPage;
